/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModelDto } from '../../models/user-model-dto';

export interface AdminControllerPutUser$Params {
  uuid: string;
      body: UserModelDto
}

export function adminControllerPutUser(http: HttpClient, rootUrl: string, params: AdminControllerPutUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
  const rb = new RequestBuilder(rootUrl, adminControllerPutUser.PATH, 'put');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserModelDto>;
    })
  );
}

adminControllerPutUser.PATH = '/admin/user/{uuid}';
